<script lang="ts">
    import { route } from './helpers/router';
    import Modals from './shared_components/modals/Modals.svelte';
    import { SvelteToast } from '@zerodevx/svelte-toast';
</script>

<svelte:component this={route()} />

<Modals />
<SvelteToast />


